import React, { useEffect, useState } from 'react';
import { Container, Header } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { startEpic } from 'volto-epics-addon/helpers';
import { EPIC_FILE_UPLOAD } from 'volto-base-addon/constants';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  startingUploadProcess: {
    id: 'startingUploadProcess',
    defaultMessage: 'Starting upload process..',
  },
  mustLoginFirst: {
    id: 'mustLoginFirst',
    defaultMessage: 'You must log in first.',
  },
});

const Page = () => {
  const token = useSelector((state) => state.userSession.token);
  const intl = useIntl();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  // Start the epic
  useEffect(() => {
    setIsAuthenticated(!!token);
    setIsVisible(true);

    if (!!token) {
      let destinationPath = '/uploads';

      startEpic(EPIC_FILE_UPLOAD, {
        destinationPath: destinationPath,
      });
    }
  }, [token]);

  return isVisible ? (
    isAuthenticated ? (
      <Container className="file-upload-start-container">
        <Header> {intl.formatMessage(messages.startingUploadProcess)} </Header>
      </Container>
    ) : (
      <Container className="file-upload-start-container">
        <Header> {intl.formatMessage(messages.mustLoginFirst)} </Header>
      </Container>
    )
  ) : (
    <Container className="file-upload-start-container"></Container>
  );
};

export default Page;
